// import React, { useState, useEffect } from "react";
// import payrollService from "../../services/payrollService";
// import Notification from "../../components/UI/Notification";
// import { Settings, Plus, Trash2, Save } from "lucide-react";

// const PayrollSettingsNew = () => {
//   const [settings, setSettings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [notification, setNotification] = useState(null);
//   const [activeCategory, setActiveCategory] = useState("general");
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [newSetting, setNewSetting] = useState({
//     setting_name: "",
//     setting_value: "",
//     description: "",
//     category: "",
//     is_editable: true,
//   });

//   const categories = ["general", "calculation", "statutory", "notifications"];

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     setLoading(true);
//     try {
//       const response = await payrollService.getAllSettings();
//       console.log("Fetched setting components:", response);

//       if (response.message) {
//         setSettings(response.data || []);
//       }
//     } catch (error) {
//       setNotification({ type: "error", message: "Failed to fetch settings" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddSetting = async (e) => {
//     e.preventDefault();
//     try {
//       await payrollService.createSetting(newSetting);
//       setNotification({ type: "success", message: "Setting added" });
//       setShowAddModal(false);
//       setNewSetting({
//         setting_name: "",
//         setting_value: "",
//         description: "",
//         category: "",
//         is_editable: true,
//       });
//       fetchSettings();
//     } catch (error) {
//       setNotification({ type: "error", message: "Failed to add setting" });
//     }
//   };

//   return (
//     <div className="p-6 font-poppins">
//       {notification && (
//         <Notification
//           type={notification.type}
//           message={notification.message}
//           onClose={() => setNotification(null)}
//         />
//       )}

//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
//             Payroll Settings
//           </h1>
//           <p className="text-gray-600 dark:text-gray-400 mt-1">
//             Configure system settings
//           </p>
//         </div>
//         <button
//           onClick={() => setShowAddModal(true)}
//           className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium"
//         >
//           <Plus size={18} />
//           Add Setting
//         </button>
//       </div>

//       {/* Category Tabs */}
//       <div className="flex gap-2 mb-6">
//         {categories.map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setActiveCategory(cat)}
//             className={`px-4 py-2 rounded-md font-medium transition-colors ${
//               activeCategory === cat
//                 ? "bg-blue-600 text-white"
//                 : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
//             }`}
//           >
//             {cat.charAt(0).toUpperCase() + cat.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Add Setting Modal */}
//       {showAddModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001] p-4">
//           <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full">
//             <div className="p-6 border-b border-gray-200 dark:border-gray-700">
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Add Setting
//               </h3>
//             </div>
//             <form onSubmit={handleAddSetting} className="p-6 space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                   Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={newSetting.setting_name}
//                   onChange={(e) =>
//                     setNewSetting({
//                       ...newSetting,
//                       setting_name: e.target.value,
//                     })
//                   }
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                   Value *
//                 </label>
//                 <input
//                   type="text"
//                   value={newSetting.setting_value}
//                   onChange={(e) =>
//                     setNewSetting({
//                       ...newSetting,
//                       setting_value: e.target.value,
//                     })
//                   }
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                   Category *
//                 </label>
//                 <select
//                   value={newSetting.category}
//                   onChange={(e) =>
//                     setNewSetting({ ...newSetting, category: e.target.value })
//                   }
//                   required
//                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
//                 >
//                   {categories.map((cat) => (
//                     <option key={cat} value={cat}>
//                       {cat}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                   Description
//                 </label>
//                 <textarea
//                   value={newSetting.description}
//                   onChange={(e) =>
//                     setNewSetting({
//                       ...newSetting,
//                       description: e.target.value,
//                     })
//                   }
//                   rows="3"
//                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
//                 />
//               </div>
//               <div className="flex justify-end gap-3">
//                 <button
//                   type="button"
//                   onClick={() => setShowAddModal(false)}
//                   className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 font-medium"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium"
//                 >
//                   Add
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PayrollSettingsNew;
import React, { useState, useEffect } from "react";
import payrollService from "../../services/payrollService";
import Notification from "../../components/UI/Notification";
import { Settings, Plus, Trash2, Save, Edit } from "lucide-react";

const PayrollSettingsNew = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [activeCategory, setActiveCategory] = useState("general");
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [newSetting, setNewSetting] = useState({
    setting_name: "",
    setting_value: "",
    description: "",
    category: "",
    is_editable: true,
    data_type: "string",
  });

  const categories = ["general", "calculation", "statutory", "notifications"];

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await payrollService.getAllSettings();
      console.log("Fetched setting components:", response);

      if (response.message) {
        setSettings(response.data || []);
      }
    } catch (error) {
      setNotification({ type: "error", message: "Failed to fetch settings" });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (setting) => {
    setNewSetting({
      ...setting,
      data_type: setting.data_type || "string",
    });
    setEditingId(setting.id);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await payrollService.updateSetting(editingId, newSetting);
        setNotification({ type: "success", message: "Setting updated" });
      } else {
        await payrollService.createSetting(newSetting);
        setNotification({ type: "success", message: "Setting added" });
      }
      setShowModal(false);
      setEditingId(null);
      setNewSetting({
        setting_name: "",
        setting_value: "",
        description: "",
        category: "",
        is_editable: true,
        data_type: "string",
      });
      fetchSettings();
    } catch (error) {
      setNotification({ type: "error", message: "Failed to save setting" });
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
    setNewSetting({
      setting_name: "",
      setting_value: "",
      description: "",
      category: "",
      is_editable: true,
      data_type: "string",
    });
  };

  const renderValueInput = () => {
    if (newSetting.data_type === "boolean") {
      return (
        <input
          type="checkbox"
          checked={
            newSetting.setting_value === "true" ||
            newSetting.setting_value === true
          }
          onChange={(e) =>
            setNewSetting({
              ...newSetting,
              setting_value: e.target.checked ? "true" : "false",
            })
          }
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
      );
    } else {
      return (
        <input
          type="text"
          value={newSetting.setting_value}
          onChange={(e) =>
            setNewSetting({
              ...newSetting,
              setting_value: e.target.value,
            })
          }
          required={!editingId}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
        />
      );
    }
  };

  const filteredSettings = settings.filter(
    (s) => s.category === activeCategory
  );

  if (loading) {
    return (
      <div className="p-6 font-poppins">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Payroll Settings
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Configure system settings
            </p>
          </div>
        </div>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-300 rounded w-1/4 mb-4"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 font-poppins">
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Payroll Settings
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Configure system settings
          </p>
        </div>
        <button
          onClick={() => setShowModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium"
        >
          <Plus size={18} />
          Add Setting
        </button>
      </div>

      {/* Category Tabs */}
      <div className="flex gap-2 mb-6">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-2 rounded-md font-medium transition-colors ${
              activeCategory === cat
                ? "bg-blue-600 text-white"
                : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            }`}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      {/* Settings Table */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Setting Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Value
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
            {filteredSettings.length > 0 ? (
              filteredSettings.map((setting) => (
                <tr
                  key={setting.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                    {setting.setting_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                    {setting.setting_value}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-300">
                    {setting.description}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button
                      onClick={() => handleEdit(setting)}
                      className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3 flex items-center"
                    >
                      <Edit size={16} className="mr-1" />
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  className="px-6 py-4 text-center text-gray-500 dark:text-gray-400"
                >
                  No settings found for this category.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Setting Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001] p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {editingId ? "Edit Setting" : "Add Setting"}
              </h3>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Name *
                </label>
                <input
                  type="text"
                  value={newSetting.setting_name}
                  onChange={(e) =>
                    setNewSetting({
                      ...newSetting,
                      setting_name: e.target.value,
                    })
                  }
                  required
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Data Type *
                </label>
                <select
                  value={newSetting.data_type}
                  onChange={(e) =>
                    setNewSetting({
                      ...newSetting,
                      data_type: e.target.value,
                    })
                  }
                  required
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                >
                  <option value="string">String</option>
                  <option value="boolean">Boolean</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Value *
                </label>
                <div className="relative">{renderValueInput()}</div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Category *
                </label>
                <select
                  value={newSetting.category}
                  onChange={(e) =>
                    setNewSetting({ ...newSetting, category: e.target.value })
                  }
                  required
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                >
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Description
                </label>
                <textarea
                  value={newSetting.description}
                  onChange={(e) =>
                    setNewSetting({
                      ...newSetting,
                      description: e.target.value,
                    })
                  }
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                />
              </div>
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium"
                >
                  {editingId ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PayrollSettingsNew;
